import React, { useEffect, useState } from "react";
import api from "../services/api";

function Courses() {

const [title,setTitle] = useState("");
const [industryId,setIndustryId] = useState("");

const [courses,setCourses] = useState([]);
const [industries,setIndustries] = useState([]);

const [editingId,setEditingId] = useState(null);

const [filterIndustry,setFilterIndustry] = useState("");

const [thumbnail, setThumbnail] = useState(null);

const role = localStorage.getItem("role");   // 👈 ROLE CHECK


useEffect(()=>{

loadCourses();
loadIndustries();

},[]);


const loadCourses = async ()=>{

const res = await api.get("/courses");
setCourses(res.data.data || []);

};


const loadIndustries = async ()=>{

const res = await api.get("/industries");
setIndustries(res.data.data || []);

};


const saveCourse = async ()=>{

if(!title || !industryId){
alert("Enter course title and industry");
return;
}

try{

const formData = new FormData();
formData.append("title", title);
formData.append("industry_id", industryId);

if (thumbnail) {
  formData.append("thumbnail", thumbnail); // 🔥 FILE
}

if(editingId){

await api.put(`/courses/${editingId}`, formData, {
  headers: { "Content-Type": "multipart/form-data" }
});

alert("Course updated");

}else{

await api.post("/courses", formData, {
  headers: { "Content-Type": "multipart/form-data" }
});

alert("Course created");

}

setTitle("");
setIndustryId("");
setThumbnail(null);
setEditingId(null);

loadCourses();

}catch(err){
console.log(err.response?.data);
alert(err.response?.data?.message || "Operation failed");
}

};

const editCourse = (course) => {
  setTitle(course.title);
  setIndustryId(course.industry_id);
  setEditingId(course.id);

  // Optional: reset thumbnail when editing
  setThumbnail(null);
};

const deleteCourse = async (id)=>{

const confirmDelete = window.confirm("Delete this course?");

if(!confirmDelete) return;

try{

await api.delete(`/courses/${id}`);
loadCourses();

}catch(err){

alert("Delete failed");

}

};


const filteredCourses = filterIndustry
? courses.filter(c=>c.industry_id===filterIndustry)
: courses;


return(

<div style={{padding:"30px"}}>

<h2 style={{marginBottom:"25px"}}>Courses</h2>


{/* -------- CREATE / EDIT COURSE CARD -------- */}

<div style={card}>

<h3 style={{marginBottom:"15px"}}>
{editingId ? "Edit Course" : "Create Course"}
</h3>

<div style={{display:"flex",flexDirection:"column",gap:"10px",maxWidth:"450px"}}>

<input
  type="file"
  accept="image/*"
  onChange={(e) => setThumbnail(e.target.files[0])}
/>

<input
placeholder="Course Title"
value={title}
onChange={(e)=>setTitle(e.target.value)}
style={input}
/>

<select
value={industryId}
onChange={(e)=>setIndustryId(e.target.value)}
style={input}
>

<option value="">Select Industry</option>

{industries.map(i=>(

<option key={i.id} value={i.id}>
{i.name}
</option>

))}

</select>

<button
style={primaryBtn}
onClick={saveCourse}
>
{editingId ? "Update Course" : "Add Course"}
</button>

</div>

</div>


{/* -------- COURSES LIST CARD -------- */}

<div style={card}>

<h3 style={{marginBottom:"20px"}}>Courses List</h3>

<select
value={filterIndustry}
onChange={(e)=>setFilterIndustry(e.target.value)}
style={{...input,marginBottom:"15px",maxWidth:"250px"}}
>

<option value="">All Industries</option>

{industries.map(i=>(

<option key={i.id} value={i.id}>
{i.name}
</option>

))}

</select>


<table style={table}>

<thead style={tableHeader}>

<tr>
<th>Course Name</th>
<th>Industry</th>
<th>Actions</th>
</tr>

</thead>

<tbody>

{filteredCourses.map(course=>(

<tr key={course.id} style={row}>

<td>{course.title}</td>

<td>{course.industry_name}</td>

<td>

<button
style={editBtn}
onClick={()=>editCourse(course)}
>
Edit
</button>

{/* DELETE ONLY FOR MASTER ADMIN */}

{role === "master_admin" && (

<button
style={deleteBtn}
onClick={()=>deleteCourse(course.id)}
>
Delete
</button>

)}

</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

)

}


/* ---------- UI STYLES ---------- */

const card = {

background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
marginBottom:"30px"

};

const input = {

padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px",
fontSize:"14px"

};

const primaryBtn = {

background:"#2c3e50",
color:"#fff",
border:"none",
padding:"10px",
borderRadius:"6px",
cursor:"pointer",
width:"160px"

};

const editBtn = {

background:"#f39c12",
border:"none",
color:"#fff",
padding:"6px 12px",
marginRight:"8px",
borderRadius:"4px",
cursor:"pointer"

};

const deleteBtn = {

background:"#e74c3c",
border:"none",
color:"#fff",
padding:"6px 12px",
borderRadius:"4px",
cursor:"pointer"

};

const table = {

width:"100%",
borderCollapse:"collapse"

};

const tableHeader = {

background:"#f5f6fa",
textAlign:"left"

};

const row = {

borderBottom:"1px solid #eee"

};

export default Courses;
